import React from 'react';
import Grid from "@material-ui/core/Grid";

import ListViewHeader from "../List/ListViewHeader";
import ListView from "../List/ListView";
//@ts-ignore
import TreeEntry from "../../primitives/Entries/TreeEntry";
//@ts-ignore
import ModelEntry from "../../primitives/Entries/ModelEntry";
//@ts-ignore
import { frontendFilter } from "../../../Utils/UseFilterKey";

interface Props {
  listTitle: string;
  entity: any;
  selectedEntityId: number;
  doPickerClick: (id: number) => void;
  pickModelsOnly?: boolean;
  filterInput: string;
  handleFilterChange: (e) => void;
  doFrontEndFilter?: boolean;
  handleFilterSubmit: (e) => void;
  updateList: (limit: number, offset: number) => void;
  listViewId: string;
  defaultText?: string;
}

interface State {
  sort: (i: any) => any;
}

class PickerListView extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      sort: (i: any) => i
    };
  }

  handleSortChange = (method: any) => {
    this.setState({ sort: method });
  };

  getEntryHeader = () => {
    const { listTitle, entity, filterInput, handleFilterChange } = this.props;
    return (
      <ListViewHeader
        isPicker={{ listTitle }}
        sort={{ onChange: this.handleSortChange }}
        filter={{
          input: filterInput,
          submit: e => e.preventDefault(),
          change: e => handleFilterChange(e),
        }}
      />
    );
  };

  getEntryList = () => {
    const { sort } = this.state;
    const { listTitle, doPickerClick, entity, selectedEntityId, filterInput, doFrontEndFilter } = this.props;
    let items = entity.items && sort(entity.items);
    if (doFrontEndFilter) {
      items = entity.items && sort(frontendFilter(entity.items, filterInput));
    }
    if (listTitle === 'Trees') {
      return items.map((item: any) => {
        const match = {
          params: {
            id: item.id,
            treeType: item.tree_type,
          },
        };
        return (
          <TreeEntry
            key={item.id}
            treeDetails={item}
            selected={selectedEntityId === item.id}
            isPicker
            handleChange={() => doPickerClick(item.id)}
            match={match}
          />
        );
      });
    } else {
      return items.map((item: any) => (
        <ModelEntry
          key={item.id}
          detail={item}
          selected={selectedEntityId === item.id}
          isPicker
          handleChange={() => doPickerClick(item.id)}
        />
      ));
    }
  };

  render() {
    const { entity, pickModelsOnly, updateList, listViewId, defaultText } = this.props;
    return (
      <Grid item xs={12} sm={12} md={6} lg={pickModelsOnly ? 4 : 3}>
        <ListView
          header={this.getEntryHeader()}
          items={this.getEntryList()}
          itemTotal={entity.itemTotal}
          paginationEnabled={entity.paginationEnabled}
          listViewId={listViewId}
          updateList={updateList}
          isLoading={entity.isLoading}
          inDialog
          defaultText={defaultText}
        />
      </Grid>
    );
  }
}

export default PickerListView;
